module.exports = __webpack_public_path__ + "static/media/bg_signup_invite.78ae5cd3.jpg";